export default __webpack_public_path__ + "static/media/DGuo.bd451ce3.png";